import { gql, useMutation } from '@apollo/client';

import type {
  VerifyPhoneNumberMutation,
  VerifyPhoneNumberMutationVariables,
} from './__generated__/useVerifyPhoneNumber.gql';

const VERIFY_PHONE_NUMBER = gql`
  mutation VerifyPhoneNumber($input: VerifyPhoneNumberInput!) {
    verifyPhoneNumber(input: $input) {
      id
      phoneNumber
      phoneNumberVerifiedAt
    }
  }
`;

export const useVerifyPhoneNumber = () => {
  return useMutation<VerifyPhoneNumberMutation, VerifyPhoneNumberMutationVariables>(VERIFY_PHONE_NUMBER, {
    refetchQueries: ['GetCallouts'],
  });
};
